// ui/components/Modal.tsx
import React from "react";

type Props = React.PropsWithChildren<{
  title: string;
  onClose: () => void;
  width?: number | string;
  actions?: React.ReactNode;
  /** 相容：舊頁面可能會傳 open（例如 <Modal open={isOpen} ... />） */
  open?: boolean;
}>;

export function Modal({ title, onClose, children, width = 600, actions, open = true }: Props) {
  if (!open) return null;

  // 點擊 Esc 關閉
  React.useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 3000,
      }}
      onClick={onClose}
    >
      <div
        // ⚠️ 關鍵：不要讓彈窗本體被任何外部 opacity / backdrop 影響
        className="card"
        style={{
          width,
          maxWidth: "92vw",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          padding: 0,
          overflow: "hidden",

          // 強制不透明 + 實心背景（就算 .card 被改成半透明也不會被帶到）
          background: "var(--card)",
          opacity: 1,
          backdropFilter: "none",
          WebkitBackdropFilter: "none",

          // 保底：就算某些頁面沒有載入 index.css 的 card 也有正常外觀
          border: "1px solid var(--border)",
          borderRadius: "var(--radius)",
          boxShadow: "var(--shadow)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid var(--border)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#1a1d24",
          }}
        >
          <h3 className="h1" style={{ fontSize: 18, margin: 0 }}>
            {title}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "var(--muted)",
              fontSize: 20,
              cursor: "pointer",
            }}
            aria-label="close"
          >
            ×
          </button>
        </div>

        <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>{children}</div>

        {actions && (
          <div
            style={{
              padding: "16px 20px",
              borderTop: "1px solid var(--border)",
              background: "#1a1d24",
              display: "flex",
              gap: 10,
              justifyContent: "flex-end",
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
